import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../SEO';
import { useAuth } from '../App';

export const InstagramBioPage = () => {
  const { language } = useAuth();
  const [copiedBio, setCopiedBio] = useState(false);
  const [copiedCaption, setCopiedCaption] = useState(false);

  const bioText = 
`🚩 ஸ்ரீ பரந்தாமன் ஜோதிட & வைதீக சேவை | Ahobilam.com
பஞ்சாங்கம் • ஜாதகம் • பொருத்தம் • முஹூர்த்தம் • தர்மசாஸ்திர விளக்கம்
🌐 Website: https://www.ahobilam.com
🔗 அனைத்து சேவைகளுக்கும் கீழே உள்ள லிங்கை அழுத்தவும் 👇`;

  const introCaption = 
`🚩 ஸ்ரீ பரந்தாமன் ஜோதிட & வைதீக சேவை (Ahobilam.com) இன்ஸ்டாகிராமில் இணைந்துள்ளது!

கடந்த 25 வருடங்களுக்கும் மேலாக வாக்கிய பஞ்சாங்கம், தர்மசாஸ்திர சந்தேகங்கள், வைதீக காரியங்கள் மற்றும் ஜோதிட ஆலோசனைகளை வழங்கி வரும் Ahobilam.com தற்போது இன்ஸ்டாகிராமிலும்!

✨ எங்கள் சேவைகள்:
📅 தினசரி பஞ்சாங்கம் & சுப முகூர்த்தம்
❓ வைதீக & தர்மசாஸ்திர சந்தேகங்களுக்கு சாஸ்திரீய பதில்கள்
📜 கர்மாங்களின் தத்துவங்கள் & பிரயோகங்கள்
💍 இலவச வரன் தேடல் & ஆன்மீக விவாதங்கள்

🔗 எங்கள் இணையதளத்திற்கு விஜயம் செய்ய Profile Link-ஐ அழுத்தவும்!

#SriVaishnavaKendram #Ahobilam #SriVaishnava #Panchangam #DharmaSastram #Vaideeka #AstrologyTamil #Vaishnavam`;

  const copyToClipboard = (text, setCopied) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FAF6EE] via-[#FDF8ED] to-[#F5EDDA] py-8 px-4 sm:px-6">
      <SEO
        title="Welcome Instagram Visitors - Ahobilam.com"
        description="Official Link in Bio page for Ahobilam Instagram profile. Access daily Panchangam, Dharma Sastra Q&A, Matrimonial forum, and Vaideeka services."
        keywords="Ahobilam Instagram, Sri Vaishnava Kendram, Panchangam link in bio, Vaideeka Services"
      />

      <div className="max-w-md mx-auto">
        {/* Profile Card Header */}
        <div className="bg-white rounded-3xl shadow-xl p-6 border-2 border-[#D4AF37]/50 text-center mb-6 relative overflow-hidden">
          <div className="absolute -top-12 -left-12 w-28 h-28 bg-[#CC6600]/10 rounded-full blur-xl"></div>
          <div className="absolute -bottom-12 -right-12 w-28 h-28 bg-[#1A237E]/10 rounded-full blur-xl"></div>

          {/* Logo / Deity Emblem */}
          <div className="relative inline-block mb-3">
            <img
              src="/images/ahobilam-logo.png"
              alt="Ahobilam Logo"
              className="w-24 h-24 mx-auto rounded-full border-4 border-[#D4AF37] shadow-md object-cover bg-[#FAF6EE]"
              onError={(e) => { e.target.src = "/images/header_logo_ahobilam.png"; }}
            />
            <span className="absolute bottom-0 right-0 bg-[#2D5A1E] text-white text-xs px-2 py-0.5 rounded-full font-bold border-2 border-white">
              ✓ Verified
            </span>
          </div>

          <h1 className="text-xl font-extrabold text-[#1A237E] leading-tight">
            ஸ்ரீ பரந்தாமன் ஜோதிட & வைதீக சேவை
          </h1>
          <p className="text-xs font-bold text-[#CC6600] tracking-wider uppercase mt-1">
            Ahobilam.com • 25+ Years of Shastra Service
          </p>

          <p className="text-xs text-gray-700 font-medium mt-3 bg-[#FAF6EE] p-3 rounded-2xl border border-[#D4AF37]/30 leading-relaxed">
            பஞ்சாங்கம் • ஜாதகம் • பொருத்தம் • முஹூர்த்தம் • தர்மசாஸ்திர விளக்கம்
          </p>
        </div>

        {/* Action Link Buttons */}
        <div className="space-y-3.5 mb-8">
          <Link
            to="/panchangam"
            className="w-full flex items-center justify-between p-4 bg-gradient-to-r from-[#1A237E] to-[#283593] text-white rounded-2xl font-bold text-sm shadow-md hover:shadow-lg hover:scale-[1.01] transition-all border border-blue-900 group"
          >
            <span className="flex items-center gap-3">
              <span className="text-xl">📅</span>
              <span>இன்றைய பஞ்சாங்கம் & சுப முகூர்த்தம்</span>
            </span>
            <span className="group-hover:translate-x-1 transition-transform">➔</span>
          </Link>

          <Link
            to="/qa"
            className="w-full flex items-center justify-between p-4 bg-gradient-to-r from-[#CC6600] to-[#E65100] text-white rounded-2xl font-bold text-sm shadow-md hover:shadow-lg hover:scale-[1.01] transition-all border border-orange-700 group"
          >
            <span className="flex items-center gap-3">
              <span className="text-xl">❓</span>
              <span>தர்மசாஸ்திர சந்தேகங்கள் & Q&A Board</span>
            </span>
            <span className="group-hover:translate-x-1 transition-transform">➔</span>
          </Link>

          <Link
            to="/karmangalin-thathuvangal"
            className="w-full flex items-center justify-between p-4 bg-gradient-to-r from-[#2D5A1E] to-[#1B5E20] text-white rounded-2xl font-bold text-sm shadow-md hover:shadow-lg hover:scale-[1.01] transition-all border border-green-900 group"
          >
            <span className="flex items-center gap-3">
              <span className="text-xl">📜</span>
              <span>கர்மாங்களின் தத்துவங்கள் (Shastra Book)</span>
            </span>
            <span className="group-hover:translate-x-1 transition-transform">➔</span>
          </Link>

          <Link
            to="/forum"
            className="w-full flex items-center justify-between p-4 bg-gradient-to-r from-[#4A148C] to-[#6A1B9A] text-white rounded-2xl font-bold text-sm shadow-md hover:shadow-lg hover:scale-[1.01] transition-all border border-purple-900 group"
          >
            <span className="flex items-center gap-3">
              <span className="text-xl">💬</span>
              <span>இலவச வரன் தேடல் & ஆன்மீக மன்றம்</span>
            </span>
            <span className="group-hover:translate-x-1 transition-transform">➔</span>
          </Link>

          <a
            href="https://www.facebook.com/100618946679853"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-between p-4 bg-gradient-to-r from-[#1877F2] to-[#166FE5] text-white rounded-2xl font-bold text-sm shadow-md hover:shadow-lg hover:scale-[1.01] transition-all border border-blue-600 group"
          >
            <span className="flex items-center gap-3">
              <span className="text-xl">📘</span>
              <span>Sri Vaishnava Kendram FB Page</span>
            </span>
            <span className="group-hover:translate-x-1 transition-transform">↗</span>
          </a>

          <a
            href="https://wa.me/919444319401"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-between p-4 bg-gradient-to-r from-[#25D366] to-[#20bd5a] text-white rounded-2xl font-bold text-sm shadow-md hover:shadow-lg hover:scale-[1.01] transition-all border border-green-600 group"
          >
            <span className="flex items-center gap-3">
              <span className="text-xl">💬</span>
              <span>WhatsApp ஜோதிட & வைதீக ஆலோசனை</span>
            </span>
            <span className="group-hover:translate-x-1 transition-transform">↗</span>
          </a>
        </div>

        {/* Copy Helper Tools for User */}
        <div className="bg-white rounded-3xl p-5 border border-[#D4AF37]/40 shadow-sm space-y-4">
          <h3 className="text-sm font-extrabold text-[#1A237E] flex items-center gap-2">
            <span>✨</span> <span>Instagram Profile Copy Tool (உங்களுக்காக)</span>
          </h3>

          {/* Bio Text Copy */}
          <div>
            <div className="flex justify-between items-center mb-1.5">
              <span className="text-xs font-bold text-[#CC6600]">1. Instagram Profile Bio Text:</span>
              <button
                onClick={() => copyToClipboard(bioText, setCopiedBio)}
                className="text-xs bg-[#1A237E] text-white px-2.5 py-1 rounded-lg font-bold hover:bg-indigo-900 transition"
              >
                {copiedBio ? '✓ Copied!' : '📋 Copy Bio Text'}
              </button>
            </div>
            <pre className="text-xs bg-[#FAF6EE] p-3 rounded-xl border border-gray-200 whitespace-pre-wrap font-sans text-gray-800 leading-relaxed">
              {bioText}
            </pre>
          </div>

          {/* First Post Caption Copy */}
          <div>
            <div className="flex justify-between items-center mb-1.5">
              <span className="text-xs font-bold text-[#CC6600]">2. First Instagram Post Caption:</span>
              <button
                onClick={() => copyToClipboard(introCaption, setCopiedCaption)}
                className="text-xs bg-[#2D5A1E] text-white px-2.5 py-1 rounded-lg font-bold hover:bg-green-900 transition"
              >
                {copiedCaption ? '✓ Copied!' : '📋 Copy Intro Caption'}
              </button>
            </div>
            <pre className="text-xs bg-[#FAF6EE] p-3 rounded-xl border border-gray-200 whitespace-pre-wrap font-sans text-gray-800 leading-relaxed max-h-48 overflow-y-auto">
              {introCaption}
            </pre>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-6 text-xs text-gray-500 font-medium">
          <p>© {new Date().getFullYear()} Ahobilam.com. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default InstagramBioPage;
